import React from 'react';
import {IconContext} from "react-icons";
import CustomTooltip from "./CustomTooltip"; // Import the reusable tooltip component

interface MRTIconProps {
    color: string; // Color of the icon
    title: string; // Tooltip text
    icon: React.ReactNode; // Icon to display
}

const MRTIcon: React.FC<MRTIconProps> = ({color, title, icon}) => {
    return (
        <CustomTooltip title={title}>
            <span>
                <IconContext.Provider value={{size: "1.3rem", color}}>
                    {icon}
                </IconContext.Provider>
            </span>
        </CustomTooltip>
    );
};

export default MRTIcon;